import {
  APPROVE_STATUS_A,
  APPROVE_STATUS_M,
  APPROVE_STATUS_R,
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_RR,
  CLIENT_TYPE_CONST,
  SOURCE_QUEUE,
} from "constants/FormatDataContanst";
import {
  LINK_TYPE,
  TYPE_ACTION_WORKFLOW,
  TYPE_ADJUST_INVOICE,
} from "constants/IssueInvoiceConstant";
import moment from "moment";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React from "react";

export const issueInvoiceModeList = {
  VIEW_VAT_INVOICE_DETAIL: "VIEW_VAT_INVOICE_DETAIL",
  CREATE_VAT_INVOICE_DETAIL: "CREATE_VAT_INVOICE_DETAIL",
  EDIT_VAT_INVOICE_DETAIL: "EDIT_VAT_INVOICE_DETAIL",

  VIEW_SALE_INVOICE_DETAIL: "VIEW_SALE_INVOICE_DETAIL",
  CREATE_SALE_INVOICE_DETAIL: "CREATE_SALE_INVOICE_DETAIL",
  EDIT_SALE_INVOICE_DETAIL: "EDIT_SALE_INVOICE_DETAIL",

  VIEW_INVOICE_TICKETS_DETAIL: "VIEW_INVOICE_TICKETS_DETAIL",
  CREATE_INVOICE_TICKETS_DETAIL: "CREATE_INVOICE_TICKETS_DETAIL",
  EDIT_INVOICE_TICKETS_DETAIL: "EDIT_INVOICE_TICKETS_DETAIL",

  VIEW_DELIVERY_BILL_DETAIL: "VIEW_DELIVERY_BILL_DETAIL",
  CREATE_DELIVERY_BILL_DETAIL: "CREATE_DELIVERY_BILL_DETAIL",
  EDIT_DELIVERY_BILL_DETAIL: "EDIT_DELIVERY_BILL_DETAIL",

  VIEW_WAREHOUSE_AGENCY_DETAIL: "VIEW_WAREHOUSE_AGENCY_DETAIL",
  CREATE_WAREHOUSE_AGENCY_DETAIL: "CREATE_WAREHOUSE_AGENCY_DETAIL",
  EDIT_WAREHOUSE_AGENCY_DETAIL: "EDIT_WAREHOUSE_AGENCY_DETAIL",
};

export const issueInvoicePageViewList = {
  PAGE_VAT_INVOICE_HAVE_CODE: "PAGE_VAT_INVOICE_HAVE_CODE",
  PAGE_VAT_INVOICE_NONE_CODE: "PAGE_VAT_INVOICE_NONE_CODE",
  PAGE_SALE_INVOICE_HAVE_CODE: "PAGE_SALE_INVOICE_HAVE_CODE",
  PAGE_SALE_INVOICE_NONE_CODE: "PAGE_SALE_INVOICE_NONE_CODE",

  PAGE_INVOICE_TICKETS_HAVE_CODE: "PAGE_INVOICE_TICKETS_HAVE_CODE",
  PAGE_INVOICE_TICKETS_NONE_CODE: "PAGE_INVOICE_TICKETS_NONE_CODE",

  PAGE_DELIVERY_BILL_HAVE_CODE: "PAGE_DELIVERY_BILL_HAVE_CODE",
  PAGE_DELIVERY_BILL_NONE_CODE: "PAGE_DELIVERY_BILL_NONE_CODE",

  PAGE_WAREHOUSE_AGENCY_HAVE_CODE: "PAGE_WAREHOUSE_AGENCY_HAVE_CODE",
  PAGE_WAREHOUSE_AGENCY_NONE_CODE: "PAGE_WAREHOUSE_AGENCY_NONE_CODE",
};

export const KHMSHDON = {
  VAT: "1",
  SALE: "2",
  TICKET: "5",
  DELIVERY_BILL: "6",
  WAREHOUSE_AGENCY: "6",
};

export const KHHDON_LAST = {
  VAT: "T",
  SALE: "T",
  TICKET: "G",
  DELIVERY_BILL: "N",
  WAREHOUSE_AGENCY: "B",
};

export const initOptionDateLocale = {
  altInput: true,
  altFormat: "d/m/Y",
  dateFormat: "d/m/Y",
  // shorthandCurrentMonth:true,
  locale: {
    firstDayOfWeek: 1,
  },
};

export const convertDate = (data, format) => {
  if (format) {
    const type = typeof data;
    let date = null;
    if (type === "object") {
      date = Math.round(new Date(data).getTime());
    } else {
      date = data;
    }
    return moment(date).format("YYYY-MM-DD");
  } else {
    const type = typeof data;
    let date = null;
    if (type === "object") {
      date = Math.round(new Date(data).getTime() / 1000);
    } else {
      date = data;
    }
    return date;
  }
};

export const fixConvertNumberToText = text => {
  const fixArr = [
    {
      search: "bẩy",
      replace: "bảy",
    },
    {
      search: "tư",
      replace: "bốn",
    },
    {
      search: "undefined",
      replace: "",
    },
  ];
  let textFix = text;
  for (const item of fixArr) {
    textFix = replaceAll(textFix, item.search, item.replace);
  }
  return textFix;
};

export const replaceAll = (target, search, replacement) => {
  return target.split(search).join(replacement);
};

// code by: Khoa-ln
// Copy as you wish. No attribution required.
var mangso = [
  "không",
  "một",
  "hai",
  "ba",
  "bốn",
  "năm",
  "sáu",
  "bảy",
  "tám",
  "chín",
];

const dochangchuc = (so, daydu) => {
  var chuoi = "";
  var chuc = Math.floor(so / 10);
  var donvi = so % 10;
  if (chuc > 1) {
    chuoi = " " + mangso[chuc] + " mươi";
    if (donvi == 1) {
      chuoi += " mốt";
    }
  } else if (chuc == 1) {
    chuoi = " mười";
    if (donvi == 1) {
      chuoi += " một";
    }
  } else if (daydu && donvi > 0) {
    chuoi = " lẻ";
  }

  if (donvi == 5 && chuc >= 1) {
    chuoi += " lăm";
  } else if (donvi > 1 || (donvi == 1 && chuc == 0)) {
    chuoi += " " + mangso[donvi];
  }
  return chuoi;
};

const docblock = (so, daydu) => {
  var chuoi = "";
  var tram = Math.floor(so / 100);
  so = so % 100;
  if (daydu || tram > 0) {
    chuoi = " " + mangso[tram] + " trăm";
    chuoi += dochangchuc(so, true);
  } else {
    chuoi = dochangchuc(so, false);
  }
  return chuoi;
};

const dochangtrieu = (so, daydu) => {
  var chuoi = "";
  var trieu = Math.floor(so / 1000000);
  so = so % 1000000;
  if (trieu > 0) {
    chuoi = docblock(trieu, daydu) + " triệu";
    daydu = true;
  }
  var nghin = Math.floor(so / 1000);
  so = so % 1000;
  if (nghin > 0) {
    chuoi += docblock(nghin, daydu) + " nghìn";
    daydu = true;
  }
  if (so > 0) {
    chuoi += docblock(so, daydu);
  }
  return chuoi;
};

export const docso = so => {
  if (so == 0) return mangso[0];
  var chuoi = "",
    hauto = "";
  do {
    var ty = so % 1000000000;
    so = Math.floor(so / 1000000000);
    if (so > 0) {
      chuoi = dochangtrieu(ty, true) + hauto + chuoi;
    } else {
      chuoi = dochangtrieu(ty, false) + hauto + chuoi;
    }
    hauto = " tỷ";
  } while (so > 0);
  return chuoi;
};

/** @OnlyCurrentDoc */

var ChuSo = new Array(
  " không ",
  " một ",
  " hai ",
  " ba ",
  " bốn ",
  " năm ",
  " sáu ",
  " bảy ",
  " tám ",
  " chín "
);
var Tien = new Array("", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ");

//1. Hàm đọc số có ba chữ số;
const DocSo3ChuSo = baso => {
  var tram;
  var chuc;
  var donvi;
  var KetQua = "";
  tram = parseInt(baso / 100);
  chuc = parseInt((baso % 100) / 10);
  donvi = baso % 10;
  if (tram == 0 && chuc == 0 && donvi == 0) return "";
  if (tram != 0) {
    KetQua += ChuSo[tram] + " trăm ";
    if (chuc == 0 && donvi != 0) KetQua += " linh ";
  }
  if (chuc != 0 && chuc != 1) {
    KetQua += ChuSo[chuc] + " mươi";
    if (chuc == 0 && donvi != 0) KetQua = KetQua + " linh ";
  }
  if (chuc == 1) KetQua += " mười ";
  switch (donvi) {
    case 1:
      if (chuc != 0 && chuc != 1) {
        KetQua += " mốt ";
      } else {
        KetQua += ChuSo[donvi];
      }
      break;
    case 5:
      if (chuc == 0) {
        KetQua += ChuSo[donvi];
      } else {
        KetQua += " lăm ";
      }
      break;
    default:
      if (donvi != 0) {
        KetQua += ChuSo[donvi];
      }
      break;
  }
  return KetQua;
};

//2. Hàm đọc số thành chữ (Sử dụng hàm đọc số có ba chữ số)

export const docsov2 = SoTien => {
  var lan = 0;
  var i = 0;
  var so = 0;
  var KetQua = "";
  var tmp = "";
  var ViTri = new Array();
  if (SoTien < 0) return "Số tiền âm !";
  if (SoTien == 0) return "Không";
  if (SoTien > 0) {
    so = SoTien;
  } else {
    so = -SoTien;
  }
  //   if (SoTien > 8999999999999999) {
  //     //SoTien = 0;
  //     return "Số quá lớn!";
  //   }
  ViTri[5] = Math.floor(so / 1000000000000000);
  if (isNaN(ViTri[5])) ViTri[5] = "0";
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000;
  ViTri[4] = Math.floor(so / 1000000000000);
  if (isNaN(ViTri[4])) ViTri[4] = "0";
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000;
  ViTri[3] = Math.floor(so / 1000000000);
  if (isNaN(ViTri[3])) ViTri[3] = "0";
  so = so - parseFloat(ViTri[3].toString()) * 1000000000;
  ViTri[2] = parseInt(so / 1000000);
  if (isNaN(ViTri[2])) ViTri[2] = "0";
  ViTri[1] = parseInt((so % 1000000) / 1000);
  if (isNaN(ViTri[1])) ViTri[1] = "0";
  ViTri[0] = parseInt(so % 1000);
  if (isNaN(ViTri[0])) ViTri[0] = "0";
  if (ViTri[5] > 0) {
    lan = 5;
  } else if (ViTri[4] > 0) {
    lan = 4;
  } else if (ViTri[3] > 0) {
    lan = 3;
  } else if (ViTri[2] > 0) {
    lan = 2;
  } else if (ViTri[1] > 0) {
    lan = 1;
  } else {
    lan = 0;
  }
  for (i = lan; i >= 0; i--) {
    tmp = DocSo3ChuSo(ViTri[i]);
    KetQua += tmp;
    if (ViTri[i] > 0) KetQua += Tien[i];
    if (i > 0 && tmp.length > 0) KetQua += ","; //&& (!string.IsNullOrEmpty(tmp))
  }
  if (KetQua.substring(KetQua.length - 1) == ",") {
    KetQua = KetQua.substring(0, KetQua.length - 1);
  }
  KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2);
  KetQua = KetQua.replace(/,/g, " ");
  KetQua = KetQua.replace(/\s\s/g, " ");
  return KetQua; //.substring(0, 1);//.toUpperCase();// + KetQua.substring(1);
};

export const getPathNameFile = (row, filename) => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  const time = `${dd}_${mm}_${yyyy}`;
  return `${filename}_${row.ttchung_khhdon}_${row.ttchung_shdon}_${time}.docx`;
};

export const customViewField = array => {
  const object = {};
  for (const item of array) {
    object[item.field] = item;
  }
  return object;
};

export const financial = (x, fixNum) => {
  if (isFloat(x)) {
    return Number.parseFloat(x).toFixed(fixNum);
  }
  return x;
};

export const isFloat = n => {
  return Number(n) === n && n % 1 !== 0;
};

export const formatTienFinal = (ttoan_tgtttbso, dvtte) => {
  let dv = "";
  let thapPhanText = "";
  let ttoan_tgtttbchu = "";
  let listMoney = String(ttoan_tgtttbso).split(".");
  let APart = "";
  let BPart = "";
  switch (dvtte) {
    case "HKD":
    case "HKĐ":
      dv = " đô la hồng kông";
      thapPhanText = "";
      APart = docso(Math.abs(Number(listMoney[0]))).trim() + dv;
      BPart = listMoney[1]
        ? " và " + docso(Math.abs(Number(listMoney[1]))).trim() + thapPhanText
        : "";
      break;
    case "VND":
      dv = " đồng";
      thapPhanText = "";
      APart = docso(Math.abs(Number(listMoney[0]))).trim() + dv;
      BPart = listMoney[1]
        ? " và " + docso(Math.abs(Number(listMoney[1]))).trim() + thapPhanText
        : "";
      break;
    case "USD":
      dv = " đô la Mỹ";
      thapPhanText = " xu";
      APart = docso(Math.abs(Number(listMoney[0]))).trim() + dv;
      BPart = listMoney[1]
        ? " và " + docso(Math.abs(Number(listMoney[1]))).trim() + thapPhanText
        : "";
      break;
    default:
      dv = ` ${dvtte}`;
      thapPhanText = "";
      APart = docso(Math.abs(Number(listMoney[0]))).trim() + dv;
      BPart = listMoney[1]
        ? " và " + docso(Math.abs(Number(listMoney[1]))).trim() + thapPhanText
        : "";
      break;
  }
  ttoan_tgtttbchu = APart + BPart;
  return ttoan_tgtttbchu;
};

export const getTypeWorkflowMessage = typeMode => {
  let mess = "";
  switch (typeMode) {
    case TYPE_ACTION_WORKFLOW.SUBMIT:
      mess = "Gửi duyệt hóa đơn";
      break;
    case TYPE_ACTION_WORKFLOW.APPROVE:
      mess = "Duyệt hóa đơn";
      break;
    case TYPE_ACTION_WORKFLOW.REJECT:
      mess = "Từ chối duyệt hóa đơn";
      break;
    default:
      break;
  }
  return mess;
};

export const getIconFile = type => {
  let icon = "";
  switch (type) {
    case "doc":
    case "docx":
      icon = "fas fa-file-word text-primary";
      break;
    case "pdf":
      icon = "fas fa-file-pdf text-danger";
      break;
    default:
      break;
  }
  return icon;
};

export const getRowInvoiceReplaceAdjustInfo = (
  row,
  setDataCompare,
  dispatch,
  getDataLink,
  toggleCompareInvoiceModal
) => {
  let info = null;
  let dataCompare = {
    leftInvoice: null,
    rightInvoice: null,
    tthdlquan_tchdon: null,
    typeChange: null,
  };
  let textInfo = "";
  let isChild = false;
  if (row.link_type || row.tthdlquan_lhdclquan === "3") {
    // $link_type Đánh dấu trạng thái liên kết điều chỉnh/thay thế 1 => parent replace , 2 => parent adjust , 3 => child replace , 4 => child adjust
    if (row.link_type) {
      switch (row.link_type) {
        // Parent
        case LINK_TYPE.PARENT_REPLACE:
          isChild = true;
          dataCompare.typeChange = " thay thế";
          break;
        case LINK_TYPE.PARENT_ADJUST:
          isChild = true;
          dataCompare.typeChange = " điều chỉnh";
          break;
        // Child
        case LINK_TYPE.CHILD_REPLACE:
          isChild = false;
          dataCompare.typeChange = " thay thế";
          break;
        case LINK_TYPE.CHILD_ADJUST:
          isChild = false;
          dataCompare.typeChange = " điều chỉnh";
          break;
        // Child
        case LINK_TYPE.CHILD_REPLACE_TT32:
          isChild = false;
          dataCompare.typeChange = " thay thế";
          break;
        case LINK_TYPE.CHILD_ADJUST_TT32:
          isChild = false;
          dataCompare.typeChange = " điều chỉnh";
          break;
        default:
          break;
      }
    }
    if (isChild) {
      dataCompare.leftInvoice = {
        current: "",
        id: row.id,
        khmshdon: row.ttchung_khmshdon,
        khhdon: row.ttchung_khhdon,
        shdon: row.ttchung_shdon,
        nlap: tableFormateDate(row.ttchung_nlap),
      };
      // dataCompare.rightInvoice = {
      //   id: child.id,
      //   khmshdon: child.ttchung_khmshdon,
      //   khhdon: child.ttchung_khhdon,
      //   shdon: child.ttchung_shdon,
      //   nlap: tableFormateDate(child.ttchung_nlap),
      // };
    }
    // ID của hóa đơn bị hóa đơn hiện tại thay thế/ điều chỉnh
    if (!isChild) {
      textInfo = " bị";
      // dataCompare.leftInvoice = {
      //   id: root.id,
      //   khmshdon: root.ttchung_khmshdon,
      //   khhdon: root.ttchung_khhdon,
      //   shdon: root.ttchung_shdon,
      //   nlap: tableFormateDate(root.ttchung_nlap),
      // };
      dataCompare.rightInvoice = [
        {
          current: "",
          id: row.id,
          khmshdon: row.ttchung_khmshdon,
          khhdon: row.ttchung_khhdon,
          shdon: row.ttchung_shdon,
          nlap: tableFormateDate(row.ttchung_nlap),
        },
      ];
    }
    if (row.tthdlquan_lhdclquan === "3") {
      // ID của hóa đơn thay thế/ điều chỉnh cho hóa đơn hiện tại
      dataCompare.tthdlquan_tchdon = row.tthdlquan_tchdon;
      let adjust_mod = null;
      let typeChange = " thay thế";
      if (dataCompare.tthdlquan_tchdon) {
        adjust_mod = row.adjust_mod;
      } else {
        adjust_mod = row.child.adjust_mod;
      }
      switch (adjust_mod) {
        case TYPE_ADJUST_INVOICE.INCREASE:
          typeChange = " điều chỉnh tăng";
          break;
        case TYPE_ADJUST_INVOICE.DECREASE:
          typeChange = " điều chỉnh giảm";
          break;
        case TYPE_ADJUST_INVOICE.CHANGE_INFO:
          typeChange = " điều chỉnh thông tin";
          break;
        default:
          break;
      }
      dataCompare.typeChange = typeChange;
      textInfo = " bị";
      dataCompare.leftInvoice = {
        id: null,
        current: " (Thông tư 32)",
        khmshdon: row.tthdlquan_khmshdclquan,
        khhdon: row.tthdlquan_khhdclquan,
        shdon: row.tthdlquan_shdclquan,
        nlap: tableFormateDate(row.tthdlquan_nlhdclquan),
        gchu: row.tthdlquan_gchu,
      };
      dataCompare.rightInvoice = [
        {
          current: "",
          id: row.id,
          khmshdon: row.ttchung_khmshdon,
          khhdon: row.ttchung_khhdon,
          shdon: row.ttchung_shdon,
          nlap: tableFormateDate(row.ttchung_nlap),
        },
      ];
    }
    dataCompare.currentId = row.id;
    info = (
      <i
        style={{ cursor: "pointer" }}
        title={"Hiển thị thông tin hóa đơn" + textInfo + dataCompare.typeChange}
        className="font-size-17 bx bx-info-circle text-info"
        onClick={() => {
          // TO_DO
          setDataCompare(dataCompare);
          if (row.link_type) {
            dispatch(getDataLink(row.id, isChild));
          }
          toggleCompareInvoiceModal();
        }}
      ></i>
    );
  }
  return info;
};

export const checkVisibleByConditionRowData = (conditionVisible, data) => {
  let isShow = true;
  // Normal action condition
  for (const key in conditionVisible) {
    const k = key.split(".");
    let lastValue = data;
    for (const item of k) {
      lastValue = lastValue?.[item] ? lastValue[item] : null;
    }
    if (conditionVisible[key].length === 0) {
      isShow = lastValue ? true : false;
    } else {
      if (
        lastValue &&
        conditionVisible[key]?.findIndex(c => c === lastValue) === -1
      ) {
        isShow = false;
      }
    }
  }
  return isShow;
};

export const COMMON_CONDITION_VISIBLE = {
  EDIT: {
    // ttchung_shdon: [null],
    auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
    approve_status: [APPROVE_STATUS_M, APPROVE_STATUS_R],
    source: [
      null,
      SOURCE_QUEUE.QUEUE,
      SOURCE_QUEUE.QUEUE_HQ,
      SOURCE_QUEUE.DEFAULT,
    ],
  },
  EDIT_QUEUE_MSEAG: {
    // ttchung_shdon: [null],
    auth_status: [AUTH_STATUS_NEW, AUTH_STATUS_RR],
    source: [SOURCE_QUEUE.QUEUE_MSEAG],
    approve_status: [APPROVE_STATUS_A],
  },
  SEND_APPROVE: {
    approve_status: [APPROVE_STATUS_M, APPROVE_STATUS_R],
    auth_status: [AUTH_STATUS_NEW],
    source: [
      //   SOURCE_QUEUE.QUEUE_MSEAG, // Guradian thì k hiện nút gửi duyệt
      null,
      SOURCE_QUEUE.QUEUE,
      SOURCE_QUEUE.QUEUE_HQ,
      SOURCE_QUEUE.DEFAULT,
    ],
  },
  REPLACE: {
    auth_status: [AUTH_STATUS_APPROVE],
    link_type: [1], //[LINK_TYPE.PARENT_REPLACE],
    client_type: [CLIENT_TYPE_CONST.DEFAULT, CLIENT_TYPE_CONST.PULSE], //Cho phép hóa đơn PULSE/DEFAULT chạy nghiệp vụ điều chỉnh / thay thế
  },
  ADJUST: {
    auth_status: [AUTH_STATUS_APPROVE],
    link_type: [2], //[LINK_TYPE.PARENT_ADJUST],
    client_type: [CLIENT_TYPE_CONST.DEFAULT, CLIENT_TYPE_CONST.PULSE], //Cho phép hóa đơn PULSE/DEFAULT chạy nghiệp vụ điều chỉnh / thay thế
  },
};

export const checkDateWhenRelease = (
  minDateValue,
  maxDateValue,
  currentNlapValue,
  denyFunction,
  warningFunc,
  successFunc
) => {
  const nlap = moment(currentNlapValue).format("YYYY-MM-DD");
  const nlapLabel = moment(currentNlapValue).format("DD-MM-YYYY");
  console.log(
    "🚀 ~ file: ListInvoice.js ~ line 685 ~ useEffect ~ nlapLabel",
    nlapLabel
  );

  const minDate = moment(minDateValue).format("YYYY-MM-DD");
  const minDateLabel = moment(minDateValue).format("DD-MM-YYYY");
  console.log("🚀 ~ file: utils.js ~ line 685 ~ minDateLabel", minDateLabel);

  const maxDate = moment(maxDateValue).format("YYYY-MM-DD");
  const maxDateLabel = moment(maxDateValue).format("DD-MM-YYYY");
  console.log(
    "🚀 ~ file: ListInvoice.js ~ line 688 ~ useEffect ~ maxDateLabel",
    maxDateLabel
  );

  let checkOpenWarning = minDate < nlap;
  let checkDenyRelease = nlap < maxDate;
  if (maxDateValue && checkDenyRelease) {
    denyFunction(nlapLabel, minDateLabel, maxDateLabel);
  } else if (minDateValue && checkOpenWarning) {
    warningFunc(nlapLabel, minDateLabel, maxDateLabel);
  } else {
    successFunc();
  }
};
